const p = (n, t, r) => {
  if (!t && typeof r == "string")
    return r ? [`${n}--${r}`] : [];
  if (typeof t == "string" || typeof t == "number")
    return [`${n}--${t}`];
  const $ = t ? Object.keys(t).map((o) => `${n}-${o}--${t[o]}`) : [];
  return typeof r == "string" && !(t != null && t.xs) ? [`${n}-xs--${r}`, ...$] : $;
};
export {
  p as getResponsiveLayoutModifiers
};
